import { render, staticRenderFns } from "./unverified_email_modal.vue?vue&type=template&id=2ac7f06f&scoped=true&"
import script from "./unverified_email_modal.vue?vue&type=script&lang=js&"
export * from "./unverified_email_modal.vue?vue&type=script&lang=js&"
import style0 from "./unverified_email_modal.vue?vue&type=style&index=0&id=2ac7f06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac7f06f",
  null
  
)

export default component.exports